import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { SchoolServices } from '../../../services';
import { ConfigurationServices } from '../../../../configuration/services';

/**
 * Generated class for the MenuPartialDishesSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-classrooms-partial-teachers-selected',
    templateUrl: 'classrooms-partial-teachers-selected.html',
})
export class ClassroomsPartialTeachersSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public schoolServices: SchoolServices,
        public configurationServices: ConfigurationServices) {

    }

    restaurants: any;
    async delete(index) {

        this.schoolServices.classroom_teachers_array_tmp.splice(index, 1);
        //
        /* if (this.schoolServices.classroom_update_state) {
 
             var loadingPopup = this.loadingCtrl.create({
                 spinner: 'crescent',
                 content: 'Eliminando alumnos del profesor...'
             });
             loadingPopup.present();
 
             for (let student of this.schoolServices.classroom_students_array_tmp) {
                 var teacher = await this.configurationServices.getUser(this.schoolServices.classroom_teachers_array_tmp[index][2]);
 
                 this.restaurants = teacher.restaurants;
 
                 let arr = [];
                 for (let k in this.restaurants) {
                     arr.push(this.restaurants[k]);
                 }
 
                 var _index_res = arr.findIndex(e => e.UID_RESTAURANT === student[0]);
 
                 if (_index_res >= 0) {
                     //delete
                     arr.splice(_index_res, 1);
 
                     //create of array to object
                     const obj = {};
                     arr.forEach((item, index) => {
                         obj[index] = item;
                     })
 
                     this.restaurants = obj;
 
                     //update
                     this.configurationServices.afs.collection('users').doc(teacher.UID).update({
                         'restaurants': this.restaurants,
                     })
                 }
 
 
 
             }
             loadingPopup.dismiss();
 
             this.schoolServices.classroom_teachers_array_tmp.splice(index, 1);
 
 
         } else {
             
         this.schoolServices.classroom_teachers_array_tmp.splice(index, 1);
         }*/



    }


}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-teachers-select/classrooms-partial-teachers-selected/classrooms-partial-teachers-selected.ts